import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { IManagerSpecialRequest } from '@shared/shared/interfaces/manager-special-request.interfaces';
import { ApiEndpoint } from '../enums/api-endpoints.enum';

@Injectable({ providedIn: 'root' })
export class ManagerSpecialRequestService {
  constructor(private http: HttpClient) {}

  public createManagerSpecialRequest(data: IManagerSpecialRequest) {
    return this.http.post(ApiEndpoint.MANAGER_SPECIAL_REQUEST, data);
  }
}
